module.exports = __webpack_public_path__ + "images/bd13093f4015bb8b2d99dcea8a300606-google_play.png";